export const TEAM_ID_TO_TWITTER_HANDLE_TEXT = {
  AFG: "AFG",
  AUS: "AUS",
  BGD: "BAN",
  ENG: "ENG",
  IND: "IND",

  NLD: "NED",
  NZL: "NZ",
  PAK: "PAK",
  ZAF: "SA",
  LKA: "SL",
};
